export default {
    module: 'pages/about'
};
